import type { Visit } from ".";

export const VisitsColumns: Array<{
  id: keyof Visit;
  label: string;
}> = [
  { id: "date", label: "Data" },
  { id: "registeredBy", label: "Registrado por" },
  { id: "visitType", label: "Tipo" },
  { id: "attachmentsCount", label: "Anexos" },
] as const;
